import React from 'react';
import LayoutDashboard from '../../layout';
import { Switch, Route } from 'react-router-dom';
import { useRouter } from 'hooks/use-router';
import AdminActivityLogList from './pages/admin-activity-log-list/admin-activity-log-list';
import AdminActivityLogDetail from './pages/admin-activity-log-detail/admin-activity-log-detail';

type TAdminActivityLog = {};

const AdminActivityLog: React.FC<TAdminActivityLog> = () => {
    const { match } = useRouter();

    return (
        <>
            <LayoutDashboard>
                <Switch>
                    <Route exact path={match.path}>
                        <AdminActivityLogList />
                    </Route>
                    <Route path={`${match.path}/:id`}>
                        <AdminActivityLogDetail />
                    </Route>
                </Switch>
            </LayoutDashboard>
        </>
    );
};

export default AdminActivityLog;
